<template>
    <!-- MenuBar.vue -->
    <div class="title" >
      <img class="logoimg" @click="goindex" src="./img/logo.png" alt="" >
      <nav class="menu-container2">
        <a
          v-for="(item, index) in menuItems"
          :key="index"
          :href="item.path"
          class="menu-item"
          active-class="active"
          exact-active-class="exact-active"
        >
          {{ item.name }}
        </a>
      </nav>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'

  // 菜单配置项
  const menuItems = ref(window.config)

  const goindex = async () => {
    window.location.href = 'http://www.fjswqxh.com' ;
  }
  </script>
  
  <style scoped>
  .title{
    height: 85px;
    border-bottom: 5px solid #e8e7e7;
    display: flex;
    justify-content: center;
    background: #f4f4f4;
  }
  .menu-container2 {
    display: flex;
    justify-content: space-around;
    padding: 0;
    width:50%;
    margin: 0;
    line-height:55px;
  }
  
  .menu-item {
    font-size:14px;
    text-align:center;
    padding: 12px 5px;
    list-style: none;
    text-decoration: none;
    color: #858484;
    transition: all 0.3s ease;
  }
  .logoimg{
    float: left;
    width: 260px;
    height: 75px;
    margin: 6px 0 0 0px;
    cursor:pointer;
  }
  /* .menu-item:hover {
    background: #e0e0e0;
  }
   */
  /* 精确匹配时的样式 */
  .menu-item.exact-active {
    color: #fff;
    border-bottom: 2px solid #ebebeb;
    background:#333
  }
  
  /* 非精确匹配时的激活状态（嵌套路由） */
  .menu-item.active:not(.exact-active) {
    color: #2196f3;
    font-weight: bold;
  }
  </style>